import * as yup from 'yup';
import { DateUtil } from '../../../utils';

export const initialValues = {
  leaveFromDate: '',
  leaveToDate: '',
  reasonForLeave: '',
  comments: '',
};

export const validationSchema = yup.object().shape({
  leaveFromDate: yup
    .date()
    .transform((curr, orig) => (orig === '' ? null : new Date(orig)))
    .typeError('From date is required')
    .required('From date is required')
    .test(
      'is-before-toDate',
      'From date must be before To date',
      function isBeforeToDate(value) {
        const { leaveToDate } = this.parent;
        if (!leaveToDate || !value) return true;
        return new Date(value) <= new Date(leaveToDate);
      },
    ),
  leaveToDate: yup
    .date()
    .transform((curr, orig) => (orig === '' ? null : new Date(orig)))
    .typeError('To date is required')
    .required('To date is required')
    .test(
      'is-after-fromDate',
      'To date must be after From date',
      function isAfterFromDate(value) {
        const { leaveFromDate } = this.parent;
        if (!leaveFromDate || !value) return true;
        return new Date(value) >= new Date(leaveFromDate);
      },
    ),
  reasonForLeave: yup.string().trim().required('Reason for leave is required'),
  comments: yup.string().nullable(),
});

export const populateFormValues = data => ({
  leaveFromDate: DateUtil.formatDateTimeToHtmlDate(data?.FromDt) || '',
  leaveToDate: DateUtil.formatDateTimeToHtmlDate(data?.ToDt) || '',
  reasonForLeave: data?.Reason || '',
  comments: data?.Comments || '',
});
